import { DISCORD_URL, RESCUE_URL, TWITTER_URL } from '@/utils/externalLinks';

const linkStyle = { color: '#A78BFA' };

export const RootErrorMessage = () => (
  <>
    Sorry, something went wrong while displaying this part of the app.
    <br />
    <br />
    Our team has been notified and is already working on a fix. Please try refreshing the page.
    <br />
    <br />
    If the issue persists and you need to manage open positions or withdraw funds, you can use{' '}
    <a href={RESCUE_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
      Perpl Rescue
    </a>
    .
    <br />
    <br />
    For updates, follow us on{' '}
    <a href={DISCORD_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
      Discord
    </a>{' '}
    or{' '}
    <a href={TWITTER_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
      X
    </a>
    .
  </>
);
